/* eslint formatjs/no-literal-string-in-jsx: off -- translation planned for Q1 2024. See https://carrotfertility.atlassian.net/wiki/spaces/PROD/pages/2190215916/WS+Support+E2E+Translation */

import React from "react"
import { Box, Stack, Typography, useTheme } from "@carrotfertility/carotene-core"
import { getFormattedAmount } from "../utils/currency-helper"
import checkMarkSrc from "../resources/images/check-mark.png"
import errorSrc from "../resources/images/error.png"

type PaymentStatusProps = {
  amount: number
  status: string
  currency: string
  description: string
  email: string
}

const PaymentStatus = (props: PaymentStatusProps): JSX.Element => {
  const theme = useTheme()
  const formattedAmount = getFormattedAmount(props.amount, props.currency)

  if (props.status === "succeeded") {
    return (
      <Stack alignItems="center" spacing={theme.spacing(theme.tokens.spacing.sm)}>
        <Box marginBlockEnd={theme.spacing(theme.tokens.spacing.lg)}>
          <img src={checkMarkSrc} alt="" width="270px" />
        </Box>
        <Typography variant="h2">Payment successful</Typography>
        <Typography align="center">
          We’ve received your {formattedAmount} payment. <br /> A confirmation email has been sent to {props.email}.
        </Typography>
      </Stack>
    )
  }

  return (
    <Stack alignItems="center" spacing={theme.spacing(theme.tokens.spacing.sm)}>
      <Box marginBlockEnd={theme.spacing(theme.tokens.spacing.xxl)}>
        <img src={errorSrc} alt="" width="300px" />
      </Box>
      <Typography variant="h2">Payment Unsuccessful</Typography>
      <Typography align="center">
        We’re unable to process your payment because {props.description}. Your credit card will not be charged, but your
        account may show a pending transaction.
      </Typography>
    </Stack>
  )
}

export default PaymentStatus
